import { render, staticRenderFns } from "./EpisodeMessages.vue?vue&type=template&id=37da29a8&"
import script from "./EpisodeMessages.vue?vue&type=script&lang=js&"
export * from "./EpisodeMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports